import { Component, h } from 'preact';
import cx from 'classnames';

import { Inquiry } from '../../../../../types/inquiries';
import { toDecimal } from '../../../../../core/decimal';

interface InquiryCollectionAmountDisplayProps {
  inquiry: Inquiry;
  onEditClick: (inquiry: Inquiry) => void;
}

export class InquiryCollectionAmountDisplay extends Component<InquiryCollectionAmountDisplayProps> {
  render(props: InquiryCollectionAmountDisplayProps) {
    const inquiry = props.inquiry;
    let formattedTotal: string = '(no data)';
    let buttonMarkup: any = "";

    if (inquiry.totalAmount) {
      formattedTotal = `PHP ${toDecimal(props.inquiry.totalAmount)}`;
    }
    if (!props.inquiry.collected) {
      buttonMarkup = <button className="btn btn-link hi-inqcolamtdisp__edit-button" onClick={ () => this.props.onEditClick(props.inquiry) }><i className="far fa-edit" /></button>
    }

    return (
      <div className="hi-inqcolamtdisp">
        <span className="hi-inqcolamtdisp__tbc-label">To be collected:</span>
        <div className="d-flex">
          <span className={ cx('hi-inqcolamtdisp__amount', {
            'hi-inqcolamtdisp__amount--collected': props.inquiry.collected
          }) }>
            { formattedTotal }
          </span>
          { buttonMarkup }
        </div>
      </div>
    );
  }
}
